import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const ButtonGroup = ({ children, className, ...rest }) => {
    return (_jsx("div", { className: classNames("eds-button-group", className), ...rest, children: children }));
};
